export default __webpack_public_path__ + "static/media/tripadvisor.6273aa40.svg";